import { BehaviorSubject } from 'rxjs';

import { Service } from '../../../symphony';

import {
	ChatViewState,
	IAnswerExplanationData,
	ICourseImages,
	IMessages,
	IQuestionData,
	ISolution,
	ISolutionData,
} from '../global-interface';
import { initialAssistantMessages } from '../global-constants';
import { CodeAssistantConfigType, IMaterialHeader, MaterialType } from '../../../api/private/learn-engine-api/learn-engine-api.interface';
import { ICode, AttemptResType, ContextAttempt } from '../../../api/public/code-assistant';

@Service()
export class SlDataService {
	public messages$ = new BehaviorSubject<IMessages[]>(
		initialAssistantMessages,
	);

	public isAssistantResponseLoading$ = new BehaviorSubject<boolean>(false);

	public assistantResponseErrorStatus$ = new BehaviorSubject<number>(null);

	public conversationId$ = new BehaviorSubject<string>(null);

	public chatViewState$ = new BehaviorSubject<ChatViewState>(undefined);

	public courseImages$ = new BehaviorSubject<ICourseImages>(undefined);

	public systemPromptId$ = new BehaviorSubject<string>(null);

	public isTestUser$ = new BehaviorSubject<boolean>(false);

	public materialHeader$ = new BehaviorSubject<IMaterialHeader>(null);

	public codes$ = new BehaviorSubject<ICode[]>([]);

	public problem$ = new BehaviorSubject<string>('');

	public session$ = new BehaviorSubject<string>(null);

	public codeAssistantConfig$ = new BehaviorSubject<
	CodeAssistantConfigType[]
	>(null);

	public aiSolutionsLoading$ = new BehaviorSubject<{
		[key: number]: boolean;
	}>({});

	public isAnswerExplanationDataLoading$ = new BehaviorSubject<boolean>(
		false,
	);

	public aiSolutionsRate$ = new BehaviorSubject<{
		[key: number]: number;
	}>({});

	public aiSolutionsIsOpenedState$ = new BehaviorSubject<{
		[key: number]: boolean;
	}>({});

	public aiSolutionsErrors$ = new BehaviorSubject<{
		[key: number]: {
			isBackToCodeButtonVisible: boolean;
			isTryAgainButtonVisible: boolean;
			errorMessage: string;
		};
	}>({});

	public aiSolutionsData$ = new BehaviorSubject<{
		[key: number]: ISolutionData;
	}>({});

	public remainingAttemptsCountData$ = new BehaviorSubject<ContextAttempt[]>(
		null,
	);

	public attemptsGlobalData$ = new BehaviorSubject<AttemptResType[]>(
		null,
	);

	public aISolutionsMaterialType$ = new BehaviorSubject<MaterialType>(null);

	public solution$ = new BehaviorSubject<ISolution>(null);

	public questionData$ = new BehaviorSubject<IQuestionData>(null);

	public answerExplanationData$ = new BehaviorSubject<IAnswerExplanationData>(
		null,
	);

	public lessonContent$ = new BehaviorSubject<string>(null);

	public courseName$ = new BehaviorSubject<string>(null);

	public answerExplanationRes$ = new BehaviorSubject<string>('');

	public isAnswerExplanationResWithError$ = new BehaviorSubject<boolean>(
		false,
	);
}
